module.exports = __webpack_public_path__ + "static/media/img16.868b8849.png";